/**
 * Hides the video element and related elements after playback has ended or been closed.
 * This is particularly useful for cleaning up after full-screen mode is exited.
 * @param {HTMLVideoElement} videoElement - The video element to hide.
 */
export function hideVideo(videoElement) {
  const videoContainer = document.getElementById('videoController');
  const closeButton = document.getElementById('closeButton');
  videoElement.style.display = 'none';
  videoContainer.style.display = 'none';
  closeButton.style.display = 'none';
  videoElement.parentNode.removeChild(videoElement);
}
